export default __webpack_public_path__ + "static/media/pokemon_trainer3.b63dc8f1.jpg";